<oui-dialog-content class="dialog-content">
  @if (isLoading()) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  } @else {
    <oui-button class="dialog-close-btn" type="icon" oui-dialog-close>
      <oui-icon>close</oui-icon>
    </oui-button>

    <div class="headline-6">Rémunération Assurance Décès Invalidité<br /></div>
    <span class="text-md">
      <br />Merci de faire votre choix pour les modalités de paiement souhaitée:
    </span>

    <div class="radio-list-container">
      <oui-radio-list class="coordinates-radio-list" [control]="commissionAdiControl">
        <oui-radio-button [value]="'precompte'">
          <div class="subtitle-1">Précompte</div>
          <span class="label-choix"
            >En une fois sur la base de 4 années de cotisations et d'un point valeur fixé
            à 2
          </span>
        </oui-radio-button>
        <oui-radio-button [value]="'recurence'">
          <div class="subtitle-1">Récurrent</div>
          <span class="label-choix"
            >Après chaque paiement sur la base de la cotisation mensuelle et d'un point
            valeur fixé à 1,5</span
          >
        </oui-radio-button>
      </oui-radio-list>
    </div>
    <div class="valide-button-container">
      <span class="info-valide-button"
        >Pris en compte lors de vos futurs contrats ADI à partir du 1er Août</span
      >
      <oui-button
        class="valide-button"
        size="small"
        [disabled]="!commissionAdiControl.valid"
        (click)="saveRenouvellementComAdi()"
        >Valider mon choix</oui-button
      >
    </div>
  }
</oui-dialog-content>
